import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { RotatingSquare } from "react-loader-spinner";
import { AuthContext } from "../../../../../Contexts/AuthContext/AuthProvider";

const NetworksUpdate = () => {
  const { authUser } = useContext(AuthContext);
  const { id } = useParams();

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [updateData, setupdateData] = useState([]);

  useEffect(() => {
    fetch(`https://api.wlfmobile.com/api/admin/withdrawal/network/view/${id}`, {
      method: "GET",
    })
      .then((res) => res.json())
      .then((data) => {
        setData(data.data);
        setLoading(false);
      });
  }, [updateData]);

  const [errorMessage, setErrorMessage] = useState({});
  const refSubmitDis = useRef();
  const handleSubmit = (event) => {
    event.preventDefault();
    setErrorMessage('');
    refSubmitDis.current.setAttribute("disabled", true);
    const formData = new FormData(event.currentTarget);
    const InpuData = Object.fromEntries(formData);
    try {
      fetch(`https://api.wlfmobile.com/api/admin/withdrawal/network/update/${id}`, {
        method: "PUT",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify(InpuData),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.success === false) {
            setErrorMessage(data?.errors);
          } else {
            toast.success(`${data?.message}`, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            setupdateData(data);
          }
          refSubmitDis.current.removeAttribute("disabled");
        })
        .catch((error) => console.log(error));
    } catch (error) {}
  };

  if (loading) {
     return (
        <>
          <div className="loader-css">
            <RotatingSquare
              visible={true}
              height="100"
              width="100"
              color="#4fa94d"
              ariaLabel="rotating-square-loading"
              wrapperStyle={{}}
              wrapperClass=""
            />
          </div>
        </>
      );
  }

  if (!authUser?.withdrawals) {
    if (authUser?.withdrawals === undefined) {
      return (
        <>
          <div className="loader-css">
            <RotatingSquare
              visible={true}
              height="100"
              width="100"
              color="#4fa94d"
              ariaLabel="rotating-square-loading"
              wrapperStyle={{}}
              wrapperClass=""
            />
          </div>
        </>
      );
    } else {
      return (
        <>
          <h1>unauthorized</h1>
        </>
      );
    }
  } else {
    return (
      <>
        <div className="d-flex mb-30 flex-wrap gap-3 justify-content-between align-items-center">
          <h6 className="page-title">Update Coin</h6>
          <div className="d-flex flex-wrap justify-content-end gap-2 align-items-center breadcrumb-plugins">
            <Link
              to="/admin/withdraw/method/network/view"
              className="btn btn-sm btn-outline-primary"
            >
              <i className="la la-undo"></i> Back
            </Link>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <form onSubmit={handleSubmit}>
                <div className="card-body">
                  <div className="payment-method-item">
                    <div className="payment-method-body">
                      <div className="row mt-4">
                        <div className="col-md-12">
                          <div className="form-group">
                            <label for="name" className="required">
                              Name
                            </label>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                name="name"
                                required=""
                                id="name"
                                defaultValue={data?.name}
                              />
                            </div>
                            {errorMessage?.name && (
                              <span className="text-danger pt-2">
                                {errorMessage?.name?.msg}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card-footer">
                  <button
                    type="submit"
                    ref={refSubmitDis}
                    className="btn btn-primary w-100 h-45"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </>
    );
  }
};

export default NetworksUpdate;
